import dayjs from 'dayjs';
/**printVersion */
export function printVersion(): void {
    const IS_PROD = ['production'].includes(process.env.NODE_ENV as string);
    const color = IS_PROD ? 'green' : '#40a9ff';
    const style = `color:#fff;background-color:${color};border-radius:2px;`;
    print('当前版本', process.env.VUE_APP_VERSION, style);
    print(IS_PROD ? '构筑日期' : '启动时间', dayjs(Number(process.env.VUE_APP_COMPILE_TIME) ?? null).format('YYYY-MM-DD HH:mm:ss'), style);
}
/**print */
function print(title: string, info: string | undefined, style: string): void {
    console.log(`%c ${title}: %c ${info ?? ''} `, style, '');
}
